import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { FiBarChart2, FiTarget, FiAward, FiUsers, FiUser, FiRadio } from 'react-icons/fi';
import { FaTwitch } from 'react-icons/fa';
import { useAuth } from '../../../context/AuthContext';
import authService from '../../../services/authService';
import './BackofficeLayout.css';

const BackofficeLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const [linkFeedback] = useState(() => {
    if (params.get('twitch_linked')) return { type: 'success', message: 'Conta Twitch ligada com sucesso!' };
    if (params.get('twitch_link_error') === 'already_linked') return { type: 'error', message: 'Essa conta Twitch já está ligada a outro utilizador.' };
    if (params.get('twitch_link_error')) return { type: 'error', message: 'Não foi possível ligar a conta Twitch. Tenta novamente.' };
    return null;
  });

  const handleLogout = async () => {
    await logout();
    navigate('/backoffice/login');
  };

  return (
    <div className="backoffice-layout">
      <aside className="backoffice-sidebar">
        <div className="sidebar-header">
          <h2>Jizon</h2>
          <span className="sidebar-badge">Backoffice</span>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/backoffice" end className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <FiBarChart2 className="nav-icon" />
            Dashboard
          </NavLink>
          <NavLink to="/backoffice/bets" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <FiTarget className="nav-icon" />
            Bets
          </NavLink>
          <NavLink to="/backoffice/challenges" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <FiAward className="nav-icon" />
            Desafios
          </NavLink>
          <NavLink to="/backoffice/partners" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <FiUsers className="nav-icon" />
            Parceiros
          </NavLink>
          <NavLink to="/backoffice/scoreboard" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <FiRadio className="nav-icon" />
            Scoreboard
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          {linkFeedback && (
            <div className={`twitch-link-feedback ${linkFeedback.type}`}>
              {linkFeedback.message}
            </div>
          )}
          <div className="twitch-link-row">
            {user?.twitchProfile ? (
              <div className="twitch-link-status linked">
                {user.twitchProfile.avatarUrl && (
                  <img className="twitch-link-avatar" src={user.twitchProfile.avatarUrl} alt="" />
                )}
                <span>Twitch ligada: <strong>{user.twitchProfile.displayName}</strong></span>
              </div>
            ) : (
              <button className="twitch-link-button" onClick={() => authService.linkTwitch()}>
                <FaTwitch />
                <span>Ligar conta Twitch</span>
              </button>
            )}
          </div>
          <div className="sidebar-footer-row">
            <div className="user-info">
              <FiUser className="user-avatar" />
              <span className="user-name">{user?.username || 'Admin'}</span>
            </div>
            <button onClick={handleLogout} className="logout-button">
              Sair
            </button>
          </div>
        </div>
      </aside>

      <main className="backoffice-main">
        <Outlet />
      </main>
    </div>
  );
};

export default BackofficeLayout;
